import type {
  HarvestSheetResponse,
  LogHarvestParams,
  LogHarvestResponse
} from "@common/types/Harvest";
import type { TaskItem } from "@common/types/Inventory";

import type { HttpTransport } from "./transport";

export type FetchHarvestSheetParams = {
  gardenId: number;
  cropId: number;
  date: string;
  taskId?: number;
};

export type FetchHarvestItemsParams = {
  gardenId: number;
  cropId: number;
  date: string;
  showOnlyGardenItems: boolean;
};

export const createHarvestLogApi = (http: HttpTransport) => ({
  fetchHarvestItems: ({
    cropId,
    date,
    gardenId,
    showOnlyGardenItems
  }: FetchHarvestItemsParams) =>
    http.get<{ items: TaskItem[] }>(`/api/gardens/${gardenId}/harvests/items`, {
      queryParams: { cropId, date, showOnlyGardenItems }
    }),

  fetchHarvestSheet: ({ cropId, date, gardenId, taskId }: FetchHarvestSheetParams) =>
    http.get<HarvestSheetResponse>(`/api/gardens/${gardenId}/harvests/new`, {
      queryParams: { cropId, date, taskId }
    }),

  logHarvest: ({ gardenId, ...harvest }: LogHarvestParams) =>
    http.post<LogHarvestResponse>(`/api/gardens/${gardenId}/harvests`, { harvest })
});
